import { Component, input } from '@angular/core';

@Component({
  selector: 'app-svg',
  standalone: true,
  host: {
    class: 'contents'
  },
  template: `
    <svg class="text-inherit {{styleClass()}}">
      <use [attr.href]="href()"></use>
    </svg>`
})
export class SvgComponent {
  styleClass = input<string>()
  href = input.required<string>()
}
